import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import MeetingsStatisticsAPI from '../../../api/MeetingsStatisticsAPI';
import BarChart from '../../../components/BarChart/BarChart';
import NoData from '../../../components/NoData/NoData';

type Props = { timeRange: { start: string; end: string } };

function NoShowsOverTime({ timeRange }: Props) {
  const { t } = useTranslation();
  const [labels, setLabels] = useState<string[]>([]);
  const [values, setValues] = useState<number[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await MeetingsStatisticsAPI.getNoShowsOverTime({ startTime: timeRange.start, endTime: timeRange.end });
        setLabels(res.data?.labels || []);
        setValues(res.data?.values || []);
      } catch (e) {
        setLabels([]);
        setValues([]);
      }
    };
    fetchData();
  }, [timeRange.start, timeRange.end]);

  if (!labels.length) return <NoData message={t('global.empty_results')} />;

  return (
    <BarChart
      title={t('stats.meetings_noshow_over_time') || 'No-shows over time'}
      xLabels={labels}
      dataSets={[{
        label: t('stats.noshow') || 'No-show',
        data: values,
        backgroundColor: ['rgba(239, 68, 68, 0.6)'],
        borderColor: ['rgba(239, 68, 68, 0.6)'],
        borderWidth: 1,
      }]}
    />
  );
}

export default NoShowsOverTime;


